import React from 'react';
import { PageSection, CTASectionContent } from '../../types/page';
import { Button } from '../ui/button';
import { ArrowRight, Phone } from 'lucide-react';

interface CTASectionProps {
  section: PageSection;
  className?: string;
}

export const CTASection: React.FC<CTASectionProps> = ({ section, className = '' }) => {
  const content = section.content as CTASectionContent;

  const backgroundStyle = content.backgroundImage 
    ? { backgroundImage: `url(${content.backgroundImage})` }
    : {};

  return (
    <section 
      className={`relative py-20 bg-cover bg-center bg-no-repeat ${className}`}
      style={backgroundStyle}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60" />
      
      <div className="relative z-10 container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          {/* Main Title */}
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
            {section.title}
          </h2>
          
          {/* Subtitle */}
          {section.subtitle && (
            <p className="text-xl md:text-2xl mb-12 opacity-90 max-w-2xl mx-auto">
              {section.subtitle}
            </p>
          )}

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            {content.primaryButton && (
              <Button 
                size="lg" 
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                onClick={() => window.location.href = content.primaryButton.link}
              >
                <Phone className="mr-3 h-6 w-6" />
                {content.primaryButton.text}
              </Button>
            )}
            
            {content.secondaryButton && (
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-black px-8 py-4 text-lg font-semibold backdrop-blur-sm bg-white/10 transition-all duration-300 transform hover:scale-105"
                onClick={() => window.location.href = content.secondaryButton!.link}
              >
                {content.secondaryButton.text}
                <ArrowRight className="ml-3 h-6 w-6" />
              </Button>
            )}
          </div>

          {/* Additional Info */}
          <div className="mt-12 flex flex-col sm:flex-row justify-center items-center gap-8 text-sm opacity-80">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-green-400 rounded-full mr-2"></div>
              Respuesta en menos de 24 horas
            </div>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-blue-400 rounded-full mr-2"></div>
              Asesoría gratuita
            </div>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-yellow-400 rounded-full mr-2"></div>
              Profesionales certificados
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600"></div>
    </section>
  );
};